import React from "react";
import style from "./dressingAppearance.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { Button, Form } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";
import { PERMISSIONS } from "../../../../constants/permissions";
import { ChipGroup } from "../../../secondary/ChipGroup/ChipGroup";
import { Controller } from "react-hook-form";
import { InfoBanner } from "../../../secondary/ReadOnlyBanner/InfoBanner";
import constants from "../../../../constants/constants.json";

export const DressingAppearanceEditMode = ({
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  listResp,
  resp,
  control,
  onCancelClick,
  isReadOnly,
}) => (
  <div>
    {isReadOnly && (
      <div className={style.read_only}>
        <ReadOnlyBanner />
      </div>
    )}
    {signedLockedAccess(assessmentDetails?.assessmentStage) ? (
      <Form setFormChangesConfirm={setFormChangesConfirm} onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.TREATMENT}>
        <section className={style.form_section}>
          <div className={style.form_section_body}>
            <div className={style.form_field} data-testid={`dressinghStatus`}>
              <div className={style.form_field_label}>
                <span>Dressing Appearance:</span>
              </div>
              <div className={style.form_field_control}>
                <Controller
                  name="dressinghStatus"
                  control={control}
                  defaultValue={resp?.dressingAppearance ?? ""}
                  render={({ onChange, onBlur, value }) => (
                    <ChipGroup name="dressinghStatus" options={listResp} value={value} onChange={onChange} onBlur={onBlur} disabled={isReadOnly}/>
                  )}
                />
              </div>
            </div>
          </div>
        </section>

        <div className="row">
          <div className="mt-4 pt-2 col-sm-12 p-0">
            <div className="offset-5 p-0">
              <Button type="submit" classes={{ className: `btn ${style.btn_save}` }} id="updateBtn" value={SAVE_BTN} disabled={isReadOnly}/>
              <Button classes={{ className: `btn ${style.btn_cancel}` }} type="button" id="cancel" value={CANCEL_BTN} onClick={onCancelClick} disabled={isReadOnly}/>
            </div>
          </div>
        </div>
      </Form>
    ) : (
      <InfoBanner message={constants.assessment.assessmentSignedLoked} />
    )}
  </div>
);
